// /**
//  * parcel - Add
//  */

// React
import React, { useContext, useEffect, useState } from 'react';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  FormControl,
  FormHelperText,
  Divider,
} from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import throttle from 'lodash/throttle';

import fulfillmentVariantsRepository from 'client-sdk/src/Repository/fulfillment-variants-repository';

// Client SDK
import Client, { VitrinClient } from 'client-sdk/src/client';
import {
  GetAllVitrinProductsRequestBuilder,
  GetPartnerCategoriesRequestBuilder,
  GetVariantsRequestBuilder,
} from 'client-sdk/src/products/products';

// Type
import { AddItemCreateParcel } from '../../parcels/interfaces';
import {
  CategoryObject,
  Variant,
  VariantFeature,
} from '../../products/interfaces';
import { Product } from '../../products/interfaces';

// helpers'
import { convertPersianDigit2English } from '../../../utils/helpers';
import AuthContext from '../../../authContext';

type Props = {
  addItem: (body: AddItemCreateParcel) => void;
  fulfillmentService: number | null;
  fulfillmentLineId: number | null;
  onClose: () => void;
};

type Inputs = {
  count: number;
  product: string;
  categoryName: string;
  productCode: number;
  countOfBox: number;
  boxCount: number;
  variant: string;
  variantCode: number;
  fulfillmentVariantCode: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& MuiDialogActions-root': {
        paddingBottom: 'none',
      },
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const token = localStorage.getItem('token') || '';

const filter = createFilterOptions<Product>();

export default function Add(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const { register, handleSubmit, errors, setValue, reset, getValues } =
    useForm<Inputs>();

  const [valueVariant, setValueVariant] = React.useState<Variant | null>(null);
  const [valueProduct, setValueProduct] = React.useState<Product | null>(null);
  const [inputValueProduct, setInputValueProduct] = React.useState('');
  const [optionsProduct, setOptionsProduct] = React.useState<Product[]>([]);
  const [valueCategory, setValueCategory] =
    React.useState<CategoryObject | null>(null);
  const [inputValueCategory, setInputValueCategory] = React.useState('');
  const [optionsCategory, setOptionsCategory] = React.useState<
    CategoryObject[]
  >([]);

  useEffect(() => {
    if (!valueCategory) {
      setValueProduct(null);
      setValueVariant(null);
    }
  }, [valueCategory]);

  const fetchProducts = React.useMemo(
    () =>
      throttle(
        (
          request: { input: string; category: object; filters: object },
          callback: (results?: Product[]) => void
        ) => {
          const { input, category, filters } = request;
          (async () => {
            const params = category?.id
              ? category?.id == 0
                ? {
                  'name.contains': input,
                  'partnerId.equals': authContext?.user?.partnerId,
                  'categoryId.specified': false,
                  ...filters,
                }
                : {
                  'name.contains': input,
                  'partnerId.equals': authContext?.user?.partnerId,
                  'categoryId.equals': category?.id,
                  size: 1000,
                  ...filters,
                }
              : {
                // 'name.contains': input,
                'partnerId.equals': authContext?.user?.partnerId,
                ...filters,
              };
            const makeRequest = new GetAllVitrinProductsRequestBuilder()
              .params(params)
              .build();
            const vitrinClient = new VitrinClient(token);
            const response = await vitrinClient.execute(makeRequest);
            const products = response.data as any;
            callback(products);
          })();
        },
        200
      ),
    []
  );

  React.useEffect(() => {
    let active = true;
    const partnerId = authContext?.user?.partnerId;
    if (
      inputValueProduct === '' &&
      (partnerId || authContext.user.role === 'SELLER_ADMIN') &&
      valueCategory
    ) {
      setOptionsProduct(valueProduct ? [valueProduct] : []);

      (async () => {
        const params = valueCategory.id
          ? {
            size: 10000,
            'partnerId.equals': authContext?.user?.partnerId || null,
            'categoryId.equals': valueCategory.id || null,
          }
          : {
            size: 10000,
            'partnerId.equals': authContext?.user?.partnerId || null,
            'categoryId.specified': 'false',
          };
        const makeRequest = new GetAllVitrinProductsRequestBuilder()
          .params(params)
          .build();
        const vitrinClient = new VitrinClient(token);
        const response = await vitrinClient.execute(makeRequest);
        const product = response.data as any;
        if (active) {
          setOptionsProduct(product as Product[]);
        }
      })();

      return undefined;
    }

    if (partnerId) {
      fetchProducts(
        { input: inputValueProduct, category: valueCategory },
        (results?: Product[]) => {
          if (active) {
            let newOptions = [] as Product[];

            if (valueProduct) {
              newOptions = [valueProduct];
            }

            if (results) {
              newOptions = [...newOptions, ...results];
            }

            setOptionsProduct(newOptions);
          }
        }
      );
    } else if (!valueCategory) {
      setOptionsProduct([]);
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      setValueProduct('');
    }

    return () => {
      active = false;
    };
  }, [
    valueCategory,
    inputValueCategory,
    valueProduct,
    inputValueProduct,
    fetchProducts,
  ]);

  const fetchCategories = React.useMemo(
    () =>
      throttle(
        (
          request: { input: string },
          callback: (results?: CategoryObject[]) => void
        ) => {
          (async () => {
            const makeRequest = new GetPartnerCategoriesRequestBuilder()
              .params({
                'partnerId.equals': authContext?.user?.partnerId
                  ? authContext?.user?.partnerId
                  : undefined,
                size: 100,
              })
              .build();
            const vitrinClient = new VitrinClient(token);
            const response = await vitrinClient.execute(makeRequest);
            const products = response.data as any;
            callback(products);
          })();
        },
        200
      ),
    []
  );

  React.useEffect(() => {
    reset('product', '');
    setValueProduct('');
  }, [optionsCategory]);

  useEffect(() => {
    if (valueProduct?.price) {
      setValue('price', valueProduct.price);
    }
  }, [valueProduct]);

  React.useEffect(() => {
    const partnerId = authContext?.user?.partnerId;
    if (inputValueCategory === '' && partnerId) {
      setOptionsCategory(valueCategory ? [valueCategory] : []);

      (async () => {
        const makeRequest = new GetPartnerCategoriesRequestBuilder()
          .params({
            size: 1000,
            'partnerId.equals': authContext?.user?.partnerId || null,
          })
          .build();
        const vitrinClient = new VitrinClient(token);
        const response = await vitrinClient.execute(makeRequest);
        const category = response.data as any;
        setOptionsCategory(category as CategoryObject[]);
      })();

      return undefined;
    }

    if (partnerId || authContext.user.role === 'SELLER_ADMIN') {
      fetchCategories(
        { input: "inputValueVariant" },
        (results?: CategoryObject[]) => {
          let newOptions = [] as CategoryObject[];

          if (valueCategory) {
            newOptions = [valueCategory];
          }

          if (results) {
            newOptions = [...newOptions, ...results];
          }
          setOptionsCategory(newOptions);
        }
      );
    }
  }, [valueCategory, inputValueCategory]);

  const onSubmit = (data: any) => {
    const {
      count,
      price,
      productCode,
      variantCode,
      fulfillmentVariantCode,
    } = data;
    props.addItem({
      count: convertPersianDigit2English(count),
      price,
      productCode,
      fulfillmentVariantCode,
      variantCode: variantCode ? variantCode : undefined,
      variant: valueProduct.variantId,
      product: valueProduct,
      category: valueCategory,
    });
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          spacing={2}
          alignItems="flex-start"
          style={{ paddingBottom: '0' }}
        >
          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <span style={{ width: '100%' }}>
                <FormControl style={{ width: '100%' }}>
                  <Autocomplete
                    id="category"
                    getOptionLabel={option =>
                      typeof option === 'string' ? option : option.name
                    }
                    filterOptions={(options, params: any) => {
                      const filtered = filter(options, params) as any;
                      return filtered;
                    }}
                    options={optionsCategory}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    noOptionsText="دسته‌بندی موجود نیست"
                    disabled={!optionsCategory.length}
                    value={valueCategory}
                    onChange={(event: any, newValue: CategoryObject | null) => {
                      setOptionsCategory(
                        newValue
                          ? [newValue, ...optionsCategory]
                          : optionsCategory
                      );
                      setValueCategory(newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setInputValueCategory(newInputValue);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        name="category"
                        label="دسته بندی ویترین"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderOption={option => {
                      return (
                        <Grid container alignItems="center">
                          <Grid item xs>
                            {option.name}
                          </Grid>
                        </Grid>
                      );
                    }}
                  />
                </FormControl>
              </span>
            </div>
          </Grid>
          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <span style={{ width: '100%' }}>
                <FormControl style={{ width: '100%' }}>
                  <Autocomplete
                    id="products"
                    getOptionLabel={option =>
                      typeof option === 'string' ? option : option.name
                    }
                    getOptionSelected={(option, value) =>
                      option.name === value.name
                    }
                    filterOptions={(options, params: any) => {
                      const filtered = filter(options, params) as any;
                      return filtered;
                    }}
                    options={optionsProduct}
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    noOptionsText="کالایی وجود ندارد"
                    disabled={!inputValueCategory}
                    value={valueProduct}
                    onChange={(event: any, newValue: Product | null) => {
                      setOptionsProduct(
                        newValue
                          ? [newValue, ...optionsProduct]
                          : optionsProduct
                      );
                      setValueProduct(newValue);
                    }}
                    onInputChange={(event, newInputValue) => {
                      setInputValueProduct(newInputValue);
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="نام کالا در ویترین"
                        name="product"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    )}
                    renderOption={option => {
                      return (
                        <Grid container alignItems="center">
                          <Grid item xs>
                            {option.name}
                          </Grid>
                        </Grid>
                      );
                    }}
                  />
                </FormControl>
              </span>
            </div>
          </Grid>
          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  id="price"
                  name="price"
                  // value={valueVariant?.id}
                  disabled={!inputValueCategory}
                  InputProps={{
                    readOnly: true,
                  }}
                  InputLabelProps={{
                    shrink: !!getValues().price,
                  }}
                  label="قیمت هر واحد"
                  inputRef={register({ required: true })}
                  error={errors.price}
                />
                <FormHelperText error focused>
                  {errors.price && 'قیمت هر واحد الزامی میباشد'}
                </FormHelperText>
              </div>
            </div>
          </Grid>

          <Grid container item xs={12} md={6} alignItems="flex-end">
            <div className={classes.item}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  id="count"
                  disabled={!inputValueCategory}
                  name="count"
                  label="تعداد"
                  inputRef={register({ required: true, pattern: /[0-9]/ })}
                  error={errors.count && true}
                />
                <FormHelperText error focused>
                  {errors.count?.type === 'required' && 'تعداد کالا الزامی میباشد'}
                </FormHelperText>
                <FormHelperText error focused>
                  {errors.count?.type === 'pattern' &&
                    'کیبورد خود را انگلیسی کنید'}
                </FormHelperText>
              </div>
            </div>
          </Grid>
          <Divider
            style={{
              margin: '10px auto 15px auto',
              width: '97%',

              alignItems: 'center',
            }}
          />
          <Grid container md={12} style={{ padding: '0 7px' }}>
            <Grid
              container
              item
              md={9}
              style={{
                alignItems: 'center',
                marginBottom: '-2px',
                paddingBottom: '0',
              }}
            >
              {/* <Typography>ایجاد کالای جدید</Typography> */}
            </Grid>
            <Grid
              container
              item
              md={3}
              style={{
                alignItems: 'center',
                marginBottom: '-2px',
                paddingBottom: '0',
              }}
            >
              <Button
                style={{ marginRight: 'auto' }}
                type="submit"
                size="medium"
                data-cy="submitAddProduct"
                autoFocus
                variant="contained"
                color="primary"
                disabled={!inputValueProduct}
              >
                {'افزودن کالا'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
